import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { DialogWizardContent } from './WizardDialogContent';
/**
 * Opens a dialog containing a multi-step wizard interface using `DialogWizardContent`.
 *
 * This function wraps `showCustomDialog` and handles rendering the wizard UI,
 * wiring up cancel and submit success behavior to also close the dialog.
 *
 * @template RootConfig - Configuration type that extends WidgetConfigBase, defaults to WidgetFormConfig.
 *
 * @param {ShowWizardDialogProps} props - Props to configure the wizard dialog, including steps, submit logic, title, and UI customization.
 * - `title`: The wizard title shown in the dialog.
 * - `steps`: An array of steps forming the wizard flow.
 * - `onCancel`: Callback triggered on cancel (will also close the dialog).
 * - `onSubmit`: Callback triggered on wizard submit.
 * - `onSubmitSuccess`: Callback triggered after a successful submission (will also close the dialog).
 * - Additional layout or dialog-related properties (excluding `content`, which is handled internally).
 *
 * @returns {void}
 */
export const showWizardDialog = (props) => {
    showCustomDialog({
        maxWidth: props.maxWidth,
        content: (close) => (React.createElement(DialogWizardContent, Object.assign({}, props, { onCancel: () => {
                var _a;
                (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
                close();
            }, onSubmitSuccess: (...params) => {
                var _a;
                (_a = props.onSubmitSuccess) === null || _a === void 0 ? void 0 : _a.call(props, ...params);
                close();
            } }))),
    });
};
